module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-3-purple.svg";